import "./InfoLand.css";

function InfoLand() {
  return (
    <>
      <div className="info-container">
        <div className="img-container">
          <img src="/images/repair.png" alt="demo" />
        </div>
        <div className="text-container">
          <h1>Discover Skilled Local Repairmen on Tumbler</h1>
          <p>
            Say goodbye to the hassle of finding reliable repair services! With
            Tumbler, you can easily discover skilled local repairmen who can fix
            anything from your broken phone to your broken car. Save time and
            money by getting your broken items fixed locally with Tumbler.
          </p>
        </div>
      </div>
      <div className="info-container2">
        <div className="img-container">
          <img src="/images/time.png" alt="demo" />
        </div>
        <div className="text-container">
          <h1>Get Your Broken Items Fixed in No Time</h1>
          <p>
            Don't let your broken items gather dust any longer! With Tumbler,
            you can get your broken items fixed in no time. Our platform
            connects you with skilled local repairmen who can fix anything from
            your broken phone to your broken house. Get started today and get
            anything fixed with Tumbler.
          </p>
        </div>
      </div>
      <div className="info-container">
        <div className="img-container">
          <img src="/images/ok.png" alt="demo" />
        </div>
        <div className="text-container">
          <h1>Join Our Community of Satisfied Customers</h1>
          <p>
            Join our community of 1M+ happy customers who have saved time and
            money by getting their broken items fixed locally with Tumbler. Our
            platform provides a convenient and reliable solution to your repair
            needs. Get started today and experience the satisfaction of joining
            our community of satisfied customers.
          </p>
        </div>
      </div>
    </>
  );
}

export default InfoLand;
